import {useEffect, useState} from 'react'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

export interface AccessPayload {
  hasCCAAccess: boolean
  canModifyCopilotSettings: boolean
}

export function useCodingAgentAccessPayload() {
  const [accessPayload, setAccessPayload] = useState<AccessPayload | null>(null)

  useEffect(() => {
    async function getPayload(): Promise<void> {
      if (accessPayload) {
        return
      }

      try {
        const resp = await verifiedFetchJSON('/copilot/agents/access')
        if (!resp.ok) {
          throw new Error(`Failed to fetch access payload: ${resp.statusText}`)
        }
        const json = (await resp.json()) as AccessPayload
        setAccessPayload(json)
      } catch (error) {
        throw new Error(`Failed to fetch coding agent access payload: ${error}`)
      }
    }
    getPayload()
  }, [accessPayload])

  return accessPayload
}
